import React from 'react'
import DraftPlayerEdit from '../DraftPlayerEdit'

function PlayerEdit({ setIsEditing }) {
    return <DraftPlayerEdit setIsEditing={setIsEditing} isDraft={false} />
}

export default PlayerEdit
